<form class="Dialog" (ngSubmit)="submit()" [formGroup]="form">
  <mat-toolbar color="primary" class="Dialog__header">
    <h2 class="Dialog__title" mat-dialog-title>{{ title }}</h2>
    <span class="flex-1"></span>
    <button mat-icon-button type="button" (click)="dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <div class="Dialog__content" mat-dialog-content>
    <div class="Dialog__form">
      <mat-form-field>
        <input matInput #focusInput formControlName="prompt" [placeholder]="label" />
      </mat-form-field>
    </div>
  </div>
  <div class="Dialog__actions" mat-dialog-actions>
    <span class="flex-1"></span>
    <button type="button" mat-button (click)="dialogRef.close()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="submit" mat-raised-button color="primary">OK</button>
  </div>
</form>
